var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeagueSelectorLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.176 3.333H7.155l2.11 2.955v19.419l-2.532 2.955h18.152l2.955-4.221H15.176V3.332z",
    fill: "#CDDCFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.577 8.57A11.782 11.782 0 004.2 16.842c0 3.213 1.282 6.127 3.362 8.257l.015-.017v-2.638a10.084 10.084 0 01-1.689-5.602c0-2.072.622-3.998 1.69-5.602V8.57zM24.25 22.752a10.085 10.085 0 001.901-5.91c0-5.311-4.087-9.668-9.287-10.097V5.052c6.134.432 10.976 5.546 10.976 11.79 0 2.153-.576 4.171-1.582 5.91H24.25z",
    fill: "#CDDCFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.049 22.752A8.444 8.444 0 0016.864 8.44v14.31h5.185z",
    fill: "#CDDCFE"
  })));
}
export default __webpack_public_path__ + "static/svg/League-SelectorLogo.svg";
export { SvgLeagueSelectorLogo as ReactComponent };